import { miniSerializeError } from '@reduxjs/toolkit';
import { SFError } from '@superfluid-finance/sdk-core';
import { getFramework } from '../../../sdkReduxConfig';
import { typeGuard } from '../../../utils';
import { CacheTime } from '../cacheTime';
import { getSerializeQueryArgs } from '../getSerializeQueryArgs';
export const createSubgraphSlice = (createRtkQueryApi) => createRtkQueryApi({
    keepUnusedDataFor: CacheTime.OneMinute,
    reducerPath: 'sfSubgraph',
    baseQuery: subgraphSliceBaseQuery(),
    tagTypes: typeGuard(['Event', 'Index', 'Stream', 'Token']),
    endpoints: (_builder) => ({}),
    serializeQueryArgs: getSerializeQueryArgs(),
});
export const subgraphSliceBaseQuery = () => handleSubgraphQueryWithFramework;
export const handleSubgraphQueryWithFramework = async ({ chainId, handle }) => {
    try {
        const framework = await getFramework(chainId);
        return { data: await handle(framework) };
    }
    catch (error) {
        if (error instanceof SFError) {
            const serializedSFError = {
                message: error.message,
                type: error.type,
            };
            if (error.errorObject) {
                serializedSFError.errorObject = miniSerializeError(error.errorObject);
            }
            return {
                error: serializedSFError,
            };
        }
        else {
            throw error;
        }
    }
};
//# sourceMappingURL=subgraphSlice.js.map